import { ReactNode } from "react";
import styled from "styled-components";

import IconSelect from "assets/images/icon_select.png";
import DownBtn from "assets/images/l_down_btn.png";

type FieldButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
};

const FieldButtonStyled = styled.button`
  &.btn_default {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 13.4rem;
    height: 4.6rem;
    padding: 0 1rem;
    color: #fff;
    letter-spacing: -0.04em;
    text-align: center;
    background-color: #454557;
    border-radius: 0.5rem;
  }
  &.btn_default.-lg {
    min-width: 13rem;
    height: 5rem;
  }
  &.btn_default.-primary {
    width: 20rem;
    background-color: rgba(0, 0, 0, 0.25);
    color: #ff6d65;
    font-size: 1.8rem;
  }

  &.btn_solid {
    min-width: 12rem;
    height: 3.8rem;
    padding: 0 2rem;
    color: #454557;
    font-size: 1.4rem;
    text-align: center;
    border-radius: 0.5rem;
    border: 1px solid #c8d2e0;
    background-color: #fff;
  }

  &.btn_action {
    z-index: 1;
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-family: "Pretendard";
    font-weight: 700;
    line-height: 1.6rem;
    font-size: 1.2rem;
    text-decoration: underline;
  }
  &.btn_action::after {
    margin-left: 1rem;
    width: 3.5rem;
    height: 3.5rem;
    background: url(${DownBtn}) no-repeat center;

    background-size: 3.5rem auto;
    content: "";
  }

  &.btn_bottomsheet {
    position: relative;
    padding: 1.4rem 5rem 1.4rem 1.6rem;
    border: 1px solid #a8b2ba;
    border-radius: 0.8rem;
    font-family: "Pretendard", sans-serif;
    color: #c9c9c9;
    text-align: left;
  }

  &.btn_bottomsheet::after {
    position: absolute;
    top: 50%;
    right: 1.5rem;
    width: 1.8rem;
    height: 1.8rem;
    margin-top: -0.9rem;
    background: url(${IconSelect}) no-repeat center;
    background-size: 1.8rem;
    content: "";
  }

  &.btn_bottomsheet.-data {
    color: #000;
  }

  &.btn_select_bottomsheet {
    position: absolute;
    bottom: 0.4rem;
    right: 0;
    min-width: 6rem;
    height: 3rem;
  }

  &.btn_alert_close {
    padding: 2rem;
    text-align: center;
    font-weight: 700;
    line-height: 2.2rem;
    letter-spacing: -0.04em;
    width: 100%;
  }
`;

const FieldButton = ({ children, type = "button", ...props }: FieldButtonProps) => {
  return (
    <>
      <FieldButtonStyled type={type} {...props}>
        {children}
      </FieldButtonStyled>
    </>
  );
};

export default FieldButton;
